import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Component, Input, OnInit, Output,  OnChanges, SimpleChanges } from '@angular/core';
import { StatusBdp } from '@core/enums/status-bdp.enum';
import { Status } from '@core/enums/status-color.enum';
import { AppService } from '@core/services/app.service';
import { ErrorHandlerService } from '@core/services/errorHandler/error-handler.service';
import { SteuerdatenService } from '@core/services/steuerdaten.service';
import { UserSettingService } from '@core/services/user-setting.service';
import { getStatusColor } from '@core/utils/getStatusColor/getStatusColor';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from '@ngneat/transloco';
import { userSettingKeys } from '@shared/constants/UsertSettingKeys';
import { DataPool } from '@shared/models/filetype/Datapool';
import { UntypedFormGroup } from '@angular/forms';
import { SecurityService } from '@core/services/security.service';
import { entitlements } from '@env/entitlements';
import {
  FilteredSteuerDaten,
  SteuerDaten,
  SteuerDatenMap,
} from '@shared/models/filetype/SteuerDaten';
import { SeriesSteuerDaten } from '@shared/models/filetype/SeriesSteuerDaten';
import { Page } from '@shared/models/Page';
import { GeneralPageInfo, SortInfo } from '@shared/models/SortInfo';
import { SelectionType } from '@swimlane/ngx-datatable';
import { AstaktSdpRequest } from '@shared/models/Astaktinfo';
import { AstaktService } from '@core/services/astakt.service';

@Component({
  standalone: false,
  selector: 'app-fcsc-bdp-inserie-select',
  templateUrl: './fcsc-bdp-inserie-select.component.html',
  styleUrls: ['./fcsc-bdp-inserie-select.component.scss'],
})
export class FcscBdpInserieSelectComponent implements OnInit, OnChanges {
  @Input() selectionType: 'checkbox' | 'radio' = 'checkbox';
  @Input() baureihe!: string;
  @Input() loadFlag!: boolean;
  @Input() smokeTestStausPassed = this.appService.getValueConstant(
    Status,
    Status.SMOKE_TEST_PASSED
  );
  smokeTestInSeries = this.appService.getValueConstant(Status, Status.IN_SERIES);
  @Input() filteredData: SteuerDatenMap[] = [];
  @Output() selectedPacket: EventEmitter<any> = new EventEmitter();
  page = new Page();
  sortConfig!: Array<{}>;
  paginationDataSetting!: any;
  params: GeneralPageInfo | undefined;
  steuerDaten: SteuerDatenMap[] = [];
  selected: SteuerDatenMap[] = [];
  SelectionType = SelectionType;
  dataTableSelection = this.selectionType === 'radio' ? SelectionType.single : SelectionType.checkbox;
  emptyMessage!: string;
  finalSelectedMap = {};
  isLoading = false;
  selectedFilter!: FilteredSteuerDaten;
  response!: any;
  form!: UntypedFormGroup;
  selectedFilterCheckBox!: FilteredSteuerDaten;
  isNaN = Number.isNaN;
 // seriesList: NgOption[] = ['v1','v3'];
  userEntitlements = this.securityService.getEntitlements();
  smokeTestStatusForFilter: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private steuerdatenService: SteuerdatenService,
    private translocoService: TranslocoService,
    private notificationService: ErrorHandlerService,
    private appService: AppService,
    private userSettingService: UserSettingService,
    private astaktService : AstaktService,
    private cdr: ChangeDetectorRef,
    private securityService: SecurityService
  ) {}

  // Add these to your component
activeDropdown: any = null;

onSelectFocus(select: any) {
  this.activeDropdown = select;
  this.cdr.detectChanges(); // Trigger change detection
  select.open();
}

onSelectBlur() {
  this.activeDropdown = null;
}

// Make sure to inject ChangeDetectorRef in constructor
// constructor(private cdr: ChangeDetectorRef) {}

  onSelect(event: any): void {
    this.selected = [...event.selected];
    this.selectedPacket.emit(this.selected);
  }

  onAstaktVersionChange(selectedVersion: string, row: any): void {
  row.defaultOrSelectedVersion = selectedVersion;
  // Update this.selected with the row and selected version
  this.selected = [row];
  this.selectedPacket.emit(this.selected);
}

  private clearSelectedEvents(): void {
    this.selected = [];
    this.selectedPacket.emit(this.selected);
  }

  onRefresh(): void {
    this.clearSelectedEvents();
    this.refreshDataTable();
  }
  ngOnInit(): void {
    this.smokeTestStatusForFilter = this.smokeTestStausPassed + ',' + this.smokeTestInSeries;

    this.dataTableSelection =
      this.selectionType === 'radio' ? SelectionType.single : SelectionType.checkbox;

    if (!this.loadFlag) {
     this.refreshDataTable();
     // this.getSteuerDatenWithoutBdp(DataPool.VORAB); // for mock-server
    }
    this.setTranslation();
  }

   ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectionType']) {
      this.dataTableSelection = this.selectionType === 'radio'
        ? SelectionType.single
        : SelectionType.checkbox;
      // For debugging:
   }
  }


   public getLatestSdps(dataPool: string, params?: FilteredSteuerDaten): void {
     console.log("Getting latestSdpFlag from datamanager")
     this.steuerdatenService.getLatestSteuerDaten(dataPool,params).subscribe(
           (data: any[]) => {
             this.response = {
              content: data, 
              totalElements: data.length, 
              number: 0,
              numberOfElements: data.length,
            };
             this.steuerDaten = data;
             this.callAstakt();
             this.cdr.detectChanges();
           },
           (error: HttpErrorResponse) => {
             this.notificationService.handleServerErrorNotification(
               error,
               'modules.admin-section.config-modal.insert-edit-api-error-message'
             );
           }
         );
  }

  private getSteuerDatenWithoutBdp(
    dataPool: string,
    params?: FilteredSteuerDaten
  ): void {
    if (this.loadFlag && !params?.baureihe && !params?.sdp && !params?.username && !params?.uploaded_at) {
       return;
    }
    this.steuerdatenService.getSteuerDaten(dataPool, params).subscribe(
      (data: SteuerDaten[]) => {
        this.response = data;
        this.steuerDaten = data && data['content'];
        if (data && data['content'] && data['content'].baureihe) {
          this.baureihe = data['content'].baureihe;
        }
      this.callAstakt();
        const sorted = this.steuerDaten?.sort((a, b) =>
          a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
        );
        this.cdr.detectChanges();
        // if (sorted) {
        //   const autoSelected = [sorted[0]];
        //   this.selected = [...autoSelected];
        //   this.selectedPacket.emit(this.selected);
        // } commented for future reference
      },
      (error: HttpErrorResponse) => {
        this.notificationService.handleServerErrorNotification(
          error,
          'modules.admin-section.config-modal.insert-edit-api-error-message'
        );
      }
    );
  }

  callAstakt(){
    for (let j = 0; j < this.steuerDaten.length; j++) {
      (this.steuerDaten[j] as any).astaktVersions = [''];
      (this.steuerDaten[j] as any).defaultOrSelectedVersion = ''; 
    }

    let sdpNames: any = [];
    for (let i = 0; i < this.steuerDaten.length; i++) {
      sdpNames.push(this.steuerDaten[i].name);
    }
    const payload: AstaktSdpRequest = { sdps : sdpNames };
    
    // Fetch all in-series data to get ASTAKT for each baureihe
    this.steuerdatenService.getSeriesSteuerDaten().subscribe({
      next: (allSeriesData: SeriesSteuerDaten[]) => {
        // Create a map of baureihe -> inSeriesAstakt for quick lookup
        const inSeriesAstaktMap: { [key: string]: string | null } = {};
        allSeriesData.forEach(item => {
          if (item.baureihe) {
            inSeriesAstaktMap[item.baureihe.toUpperCase()] = item.asTakt || null;
          }
        });
        
        // Then fetch the valid versions from backend
        this.astaktService.getAstaktSDP(payload).subscribe({
          next: (response) => {
            const dataArray = response.body || response;
            if (payload.sdps && Array.isArray(payload.sdps) && payload.sdps.length > 0) {
              if (Array.isArray(dataArray) && dataArray.length > 0) {
                for (let i = 0; i < dataArray.length; i++) {
                  for (let j = 0; j < this.steuerDaten.length; j++) {
                    if (this.steuerDaten[j].name === dataArray[i].name) {
                      const backendVersions = [...(dataArray[i].validVersions.FOR_PROMOTION || [''])];
                      // Get in-series ASTAKT for this SDP's baureihe
                      const sdpBaureihe = this.steuerDaten[j].baureihe?.toUpperCase();
                      const inSeriesAstakt = sdpBaureihe ? inSeriesAstaktMap[sdpBaureihe] : null;
                      
                      let versions: string[];
                      let defaultOrSelectedVersion: string;
                      
                      // If previous SDP was promoted with AS-Takt and it exists in backend versions
                      if (inSeriesAstakt && backendVersions.includes(inSeriesAstakt)) {
                        // Find index of previous version and take inSeriesAstakt + next 3 versions
                        const prevIndex = backendVersions.indexOf(inSeriesAstakt);
                        // Include inSeriesAstakt and next 3 versions (total 4 versions)
                        versions = backendVersions.slice(prevIndex, prevIndex + 4);
                      } else {
                        // No previous AS-Takt promotion: use all versions
                        versions = backendVersions;
                      }
                      // Always preselect the 3rd element (index 2) from the original backend versions
                      defaultOrSelectedVersion = backendVersions.length > 2 ? backendVersions[2] : (backendVersions[0] || '');
                      
                      (this.steuerDaten[j] as any).astaktVersions = versions;
                      (this.steuerDaten[j] as any).defaultOrSelectedVersion = defaultOrSelectedVersion || '';
                    }
                  }
                }
              } else {
                for (let j = 0; j < this.steuerDaten.length; j++) {
                  (this.steuerDaten[j] as any).astaktVersions = [''];
                  (this.steuerDaten[j] as any).defaultOrSelectedVersion = '';
                }
              }
            }
          }
        });
      },
      error: () => {
        // If fetching in-series data fails, proceed with fallback logic
        this.astaktService.getAstaktSDP(payload).subscribe({
          next: (response) => {
            const dataArray = response.body || response;
            if (payload.sdps && Array.isArray(payload.sdps) && payload.sdps.length > 0) {
              if (Array.isArray(dataArray) && dataArray.length > 0) {
                for (let i = 0; i < dataArray.length; i++) {
                  for (let j = 0; j < this.steuerDaten.length; j++) {
                    if (this.steuerDaten[j].name === dataArray[i].name) {
                      const versions = [...(dataArray[i].validVersions.FOR_PROMOTION || [''])];
                      // Fallback: Always preselect the 3rd index (index 2) from versions
                      const defaultOrSelectedVersion = versions.length > 2 ? versions[2] : (versions[0] || '');
                      
                      (this.steuerDaten[j] as any).astaktVersions = versions;
                      (this.steuerDaten[j] as any).defaultOrSelectedVersion = defaultOrSelectedVersion || '';
                    }
                  }
                }
              } else {
                for (let j = 0; j < this.steuerDaten.length; j++) {
                  (this.steuerDaten[j] as any).astaktVersions = [''];
                  (this.steuerDaten[j] as any).defaultOrSelectedVersion = '';
                }
              }
            }
          }
        });
      }
    });
  }

  onSort(event: Event): void {
    this.selected = [...this.selected];
  }

  cancel(): void {
    this.activeModal.close(null);
  }

  save(): void {
    this.activeModal.close(this.selected);
  }

  public getColor(value: string): string {
    const enumValue = Status[value as keyof typeof Status];
    return getStatusColor(enumValue);
  }

  public getValue(value: string): string {
    return Status[value as keyof typeof Status] || value;
  }

  public getBDPValue(value: string): string {
    let translatedText = '';
    this.translocoService
      .selectTranslate(StatusBdp[value as keyof typeof StatusBdp])
      .subscribe((resp) => {
        translatedText = resp;
      });
    return translatedText;
  }

  // This is called when translation is triggered.
  setTranslation(): void {
    this.translocoService
      .selectTranslate(
        'modules.data-management.serien-daten.data-table.empty-table-series'
      )
      .subscribe((resp) => {
        this.emptyMessage = resp;
        this.cdr.detectChanges();
      });
  }

  public truncateNote(value: string): string {
    const isExpanded = value.length > 250;
    return value.substring(0, 250) + (isExpanded ? '...' : '');
  }

  /*  pagination funcutionality */

  private async refreshDataTable() {
    await this.configPageInfoAfterInit();
    if (this.baureihe) {
      this.getSteuerDatenWithoutBdp(DataPool.VORAB, this.params);
    }
  }

  private getDataOnPageChange(page) {
    const filter = this.selectedFilter || {};
    const sortConf = [this.page.orderBy, this.page.orderDir].toString();
    if (page) {
      filter.page = (+this.page.pageNumber - 1).toString();
      filter.size = this.page.size.toString();
      filter.status = this.smokeTestStatusForFilter;
      filter.sort = sortConf.toString();
      if (!this.loadFlag) {
        filter.baureihe = this.baureihe;
      }

      this.selectedFilter = filter;
    } else {
      filter.page = '0';
      filter.size = this.page.size.toString();
      filter.sort = sortConf.toString();
      filter.status = this.smokeTestStatusForFilter;
      if (!this.loadFlag) {
        filter.baureihe = this.baureihe;
      }
      this.selectedFilter = filter;
    }
    this.appService.resetDatatableScroll();
    this.getSteuerDatenWithoutBdp(DataPool.VORAB, filter);
    const value = {
      size: filter.size,
      sort: filter.sort,
    };
    this.saveUserSetting(value);
  }

  public async setFilter(event: FilteredSteuerDaten) {
    if (!event) {
      this.steuerDaten = [];
    }
    const filter = this.selectedFilter || {};
    await this.configPageFilterInfoAfterInit(filter);
    filter.baureihe = event && event.baureihe ? event.baureihe : '';
    filter.sdp = event && event.sdp ? event.sdp : '';
    filter.username = event && event.username ? event.username : '';
    filter.uploaded_at = event && event.uploaded_at ? event.uploaded_at : '';
    filter.status = this.smokeTestStatusForFilter;
    this.selectedFilter = { ...this.selectedFilter, ...filter };
    
    if(event.latest === true){
      this.getLatestSdps(DataPool.VORAB, filter);
    }else
      this.getSteuerDatenWithoutBdp(DataPool.VORAB, filter);
  }

  public setPageSize(size) {
    this.page.pageNumber = 1;
    this.page.size = size;
    this.getDataOnPageChange(null);
  }

  public setPage(pageInfo) {
    this.page.pageNumber = pageInfo.page;
    this.getDataOnPageChange(this.page);
  }

  public sortCallback(sortInfo: SortInfo) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getDataOnPageChange(this.page);
  }

  // Saves user data on user interaction on sort, filter and page change.
  private saveUserSetting(data) {
    this.userSettingService.saveUserSetting(
      userSettingKeys.serien.inSerieActivationTable,
      data
    );
  }

  // Gets the user data or loads default ones.
  private async configPageInfoAfterInit() {
    this.paginationDataSetting =
      (await this.userSettingService.fetchUserSetting(
        userSettingKeys.serien.inSerieActivationTable
      )) || {};

    await new Promise<void>((resolve) => {
      setTimeout(() => {
        const { sort, size } = this.paginationDataSetting;
        // Sort
        const sortData = sort || 'createdAt,desc';
        const sortArray = sortData.split(',');
        const orderBy = sortArray[0];
        const orderDir = sortArray[1];
        this.sortConfig = [{ prop: orderBy, dir: orderDir }];

        // Order
        this.page.orderDir = orderDir;
        this.page.orderBy = orderBy;

        // Page
        this.page.pageNumber = 1;

        // Size
        this.page.size = size || 30;

        const sortConfArr = [this.page.orderBy, this.page.orderDir].toString();

        this.response = {
          content: [],
          totalElements: 0,
          number: 0,
          numberOfElements: 0,
        };

        this.params = {
          page: '0',
          size: size || '30',
          sort: sortConfArr,
          baureihe: this.baureihe,
          status: this.smokeTestStatusForFilter,
        };
        this.cdr.detectChanges();
        resolve();
      }, 100);
    });
  }

  private async configPageFilterInfoAfterInit(filter: any) {
    await this.configPageInfoAfterInit();
    const { sort, size } = this.paginationDataSetting;
    const sortData = sort || 'createdAt,desc';
    const sortArray = sortData.split(',');
    const orderBy = sortArray[0];
    const orderDir = sortArray[1];
    const sortConfigFilter = [orderBy, orderDir];
    filter.page = '0';
    filter.size = size || '30';
    filter.sort = sortConfigFilter.toString();
    filter.status = this.smokeTestStatusForFilter;
    if (!this.loadFlag) {
      filter.baureihe = this.baureihe;
    }
  }
}
